module.exports = __webpack_public_path__ + "img/product_icon3.510eabed.png";